import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { filter, map, size } from 'lodash';

import RoomsTableRowRender from './RoomsTableRowRender';
import { getRoomGameType } from '../../../../utils/roomUtils';

const RoomsTableRender = React.memo(({
  rooms, joinedRoom, uid, leaveRoom, activeTournament, finishedTournamentLastRound, popoverOpen, joinRoomClicked, onHover, onHoverLeave, joinRoomClickedFunc, joinPrivateRoomConfirm, fontMode, tooltipId, typeFilter, betFilter, friends,
}) => {
  if (rooms && rooms.length > 0) {
    let filteredRoomsData = [...rooms];
    const friendsIds = size(friends) > 0 ? map(friends, (item, key) => { return size(item) > 0 ? item.uid : null; }) : [];

    const isPrivateFilterEnabled = size(typeFilter) > 0 && typeFilter.includes('Privāta');
    const isOnlyPrivateFilterEnabled = isPrivateFilterEnabled && typeFilter.length === 1;
    let selectedFilter = [...typeFilter];

    if (typeFilter && typeFilter.includes('Friends')) {
      selectedFilter.splice(selectedFilter.indexOf('Friends'), 1);
    }

    if (size(selectedFilter) > 0 && !selectedFilter.includes("-")) {

      filteredRoomsData = filteredRoomsData.filter(room => selectedFilter.includes(getRoomGameType(room)) || isOnlyPrivateFilterEnabled);
      if (isPrivateFilterEnabled) {
        filteredRoomsData = filteredRoomsData.filter(room => room.globalParams && room.globalParams.privateRoom);
      }
    }

    if (typeFilter && size(typeFilter) > 0) {
      if (typeFilter && typeFilter.includes('Friends')) {
        filteredRoomsData = filter(filteredRoomsData, (item, key) => {
          if (item?.playersList) {
            return (item.playersList.player1 && friendsIds.includes(item.playersList?.player1?.uid)) || (item.playersList.player2 && friendsIds.includes(item.playersList.player2.uid)) || (item.playersList.player3 && friendsIds.includes(item.playersList.player3.uid));
          }
        });
      }
    }

    if (size(betFilter) > 0 && !betFilter.includes('-')) {
      filteredRoomsData = filteredRoomsData.filter(room => betFilter.includes(room.globalParams?.bet));
    }

    // console.log('filteredRoomsData', filteredRoomsData, rooms);

    const filteredVipRooms = filteredRoomsData.filter((item) => { return item.globalParams?.vipRoom; });
    const filteredRooms = filteredRoomsData.filter((item) => { return !item.globalParams?.vipRoom; });

    return (
      <Fragment>
        {filteredVipRooms.map((room) => {
          if (joinedRoom && joinedRoom.key && joinedRoom.globalParams && joinedRoom.playersList && room.key === joinedRoom.key) {
            return null;
          }

          return (
            <RoomsTableRowRender
              key={room.key}
              room={room}
              removal={room.removal}
              joinedRoom={joinedRoom}
              uid={uid}
              leaveRoom={leaveRoom}
              activeTournament={activeTournament}
              finishedTournamentLastRound={finishedTournamentLastRound}
              popoverOpen={popoverOpen}
              joinRoomClicked={joinRoomClicked}
              onHover={onHover}
              onHoverLeave={onHoverLeave}
              joinRoomClickedFunc={joinRoomClickedFunc}
              joinPrivateRoomConfirm={joinPrivateRoomConfirm}
              fontMode={fontMode}
              tooltipId={tooltipId}
            />
          );
        })}
        {filteredRooms.map((room, index) => {
          if (joinedRoom && joinedRoom.key && joinedRoom.globalParams && joinedRoom.playersList && room.key === joinedRoom.key) {
            return null;
          }

          return (
            <RoomsTableRowRender
              key={room.key}
              room={room}
              removal={room.removal}
              joinedRoom={joinedRoom}
              uid={uid}
              leaveRoom={leaveRoom}
              activeTournament={activeTournament}
              finishedTournamentLastRound={finishedTournamentLastRound}
              popoverOpen={popoverOpen}
              joinRoomClicked={joinRoomClicked}
              onHover={onHover}
              onHoverLeave={onHoverLeave}
              joinRoomClickedFunc={joinRoomClickedFunc}
              joinPrivateRoomConfirm={joinPrivateRoomConfirm}
              fontMode={fontMode}
              tooltipId={tooltipId}
            />
          );
        })}
      </Fragment>
    );
  }
  return null;
});

RoomsTableRender.propTypes = {
  rooms: PropTypes.arrayOf(PropTypes.shape()),
  joinedRoom: PropTypes.shape(),
  uid: PropTypes.string,
  leaveRoom: PropTypes.func.isRequired,
  activeTournament: PropTypes.string,
  popoverOpen: PropTypes.bool,
  joinRoomClicked: PropTypes.bool,
  onHover: PropTypes.func.isRequired,
  onHoverLeave: PropTypes.func.isRequired,
  joinRoomClickedFunc: PropTypes.func.isRequired,
  joinPrivateRoomConfirm: PropTypes.func.isRequired,
  tooltipId: PropTypes.string,
};

RoomsTableRender.defaultProps = {
  rooms: [],
  joinedRoom: null,
  uid: null,
  activeTournament: null,
  popoverOpen: false,
  joinRoomClicked: false,
  tooltipId: null,
};

export default RoomsTableRender;
